__webpack_require__.p = "/_Resources/Static/Packages/DigiComp.BerGen/Assets/";